import {
    Component,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
} from '@angular/core';
import { DashboardWrapperComponent } from './components/dashboard-wrapper/dashboard-wrapper.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { ApplicationService } from 'app/services/application.service';
import { ToastrService } from 'ngx-toastr';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { Subscription } from 'rxjs';
import { formatUrlEncode, htmlToString } from 'app/shared/utils';
import { ModalComponent } from 'app/components/modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [
        DashboardWrapperComponent,
        TranslateModule,
        CommonModule,
        MatIconModule,
        RouterModule,
        LoaderComponent,
        SlickCarouselModule,
        MatProgressBarModule,
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
    caseId: any;
    getUtmId: any;
    getUtmSource: any;
    campignSource: string = '';
    campaignPartner: string = '';
    isAuthenticated: boolean = false;
    userData: any;
    apiResponse: boolean = false;
    arrWhatsNewBM: any = [];
    arrWhatsNewEN: any = [];
    whatsNewData: any = [];
    whatsNewBM: any = [];
    whatsNewEN: any = [];
    moreProducts = [
        {
            name: 'COMMON.BUSINESS_FINANCING_TITLE',
            slug: 'business-financing',
            href: '/business-financing',
            bg: '#4B6EEC1A',
            ga_event_id: 'business_financing',
        },
        {
            name: 'DIGITAL_GUARANTEE',
            slug: 'digital-guarantee',
            href: '/digital-guarantee',
            bg: '#003A701A',
            ga_event_id: 'digital_guarantee',
        },
        {
            name: 'COMMON.GRANTS',
            slug: 'grants',
            href: '/grants',
            bg: '#0A0A751A',
            ga_event_id: 'grants',
        },
    ];
    statusOptions = [
        {
            value: 'Submitted',
            label: 'APPLICATION_RECENT.APPLICATION_SUBMITTED',
        },
        {
            value: 'Referred',
            label: 'APPLICATION_RECENT.APPLICATION_SUBMITTED',
        },
        {
            value: 'Reject',
            label: 'APPLICATION_RECENT.APPLICATION_REJECTED',
        },
        {
            value: 'Cancel',
            label: 'APPLICATION_RECENT.APPLICATION_CANCEL',
        },
        {
            value: 'Complete Disbursement',
            label: 'APPLICATION_RECENT.APPLICATION_DISBURSEMENT_COMPLETE',
        },
        {
            value: 'Disbursement',
            label: 'APPLICATION_RECENT.APPLICATION_DISBURSEMENT',
        },
        {
            value: 'Customer Acceptance',
            label: 'APPLICATION_RECENT.APPLICATION_CUSTOMER_ACCEPTANCE',
        },
        {
            value: 'SME Declined',
            label: 'APPLICATION_RECENT.APPLICATION_SME_DECLINED',
        },
        {
            value: 'Approval',
            label: 'APPLICATION_RECENT.APPLICATION_APPROVAL',
        },
        {
            value: 'Unmaterialized',
            label: 'APPLICATION_RECENT.APPLICATION_UNMATERIALISED',
        },
        {
            value: 'Uncontactable',
            label: 'APPLICATION_RECENT.APPLICATION_UNCONTACTABLE',
        },
        {
            value: 'Application Submission',
            label: 'APPLICATION_RECENT.APPLICATION_SUBMISSION',
        },
        {
            value: 'P2P Hosting',
            label: 'APPLICATION_RECENT.APPLICATION_P2P_HOSTING',
        },
        {
            value: 'Funded',
            label: 'APPLICATION_RECENT.APPLICATION_FUNDED',
        },
        {
            value: 'Unfunded',
            label: 'APPLICATION_RECENT.APPLICATION_UNFUNDED',
        },
    ];
    finAmountTotal: number = 0;
    applicationData: any[] = [];
    visibleApplicationCount: number = 3; // Show only 3 rows initially
    selectedLanguage: any;
    EXTERNAL = 'External';
    previewImageUrl: string | ArrayBuffer | null = null;
    profileCompletionPercent = 0;
    private langChangeSubscription: Subscription;
    @ViewChild('slickCarousel', { static: false }) slickCarousel: any;
    constructor(
        private router: Router,
        private _dashService: DashboardService,
        private applicationService: ApplicationService,
        private toastr: ToastrService,
        private translate: TranslateService,
        private cdr: ChangeDetectorRef,
        public dialog: MatDialog,
    ) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    ngOnInit() {
        this.getUtmId = JSON.parse(sessionStorage.getItem('utm_id'));
        this.getUtmSource = JSON.parse(sessionStorage.getItem('utm_source'));
        this.selectedLanguage = localStorage.getItem('language');
        // Subscribe to language changes
        this.langChangeSubscription = this.translate.onLangChange.subscribe(
            (event) => {
                this.onLanguageChange(event.lang);
            },
        );

        this.getCaseStatus();
        this.getCampaignsList();
        this.userData = this._dashService.getUser();
        this._dashService.getProfileImageUrl$().subscribe((url) => {
            this.previewImageUrl = url ?? '/assets/images/placeholder.webp';

            if (this.userData && this.previewImageUrl) {
                const profileStatus = this._dashService.getProfileCompletion(
                    this.userData,
                    this.previewImageUrl,
                );

                this.profileCompletionPercent = profileStatus.completion;
            }
        });
    }

    ngOnDestroy() {
        // Unsubscribe to prevent memory leaks
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }

    getCaseStatus() {
        this._dashService.getApplications().subscribe({
            next: (response) => {
                this.apiResponse = true;
                this.applicationData = response;
                this.finAmountTotal = this.applicationData.reduce(
                    (sum, item) => sum + item.cCaseFinamt,
                    0,
                );
                response.forEach((caseData) => {
                    this.statusOptions.forEach((item) => {
                        if (caseData.cCaseStatus === item.value) {
                            caseData.cCaseStatus = item.label;
                        } else if (caseData.cCaseStatus == null) {
                            caseData.cCaseStatus = 'null';
                        }
                    });
                });
            },
            error: (err) => {
                this.apiResponse = true;
            },
        });
    }

    getCampaignsList() {
        this.applicationService
            .getCampaign('WHATSNEW-CAMPAIGN', true)
            .subscribe({
                next: (whatsNewData) => {
                    const now = new Date().getTime() + 8 * 60 * 60 * 1000;
                    // Filter Whatsnew campaigns
                    const filteredWhatsNew = whatsNewData.filter((item) => {
                        if (item?.campaignStartDate && item?.campaignEndDate) {
                            const start = new Date(
                                item.campaignStartDate,
                            ).getTime();
                            const end = new Date(
                                item.campaignEndDate,
                            ).getTime();
                            return start <= now && end >= now;
                        }
                        return false;
                    });

                    // Process languages: Whats new
                    this.arrWhatsNewBM = [];
                    this.arrWhatsNewEN = [];
                    filteredWhatsNew.forEach((el: any) => {
                        this.processWhatsNewLanguages(
                            el,
                            this.arrWhatsNewBM,
                            this.arrWhatsNewEN,
                        );
                    });
                    // Limit to 6 banners max
                    this.whatsNewBM = this.arrWhatsNewBM.slice(0, 6);
                    this.whatsNewEN = this.arrWhatsNewEN.slice(0, 6);
                    this.whatsNewData =
                        this.selectedLanguage === 'bm'
                            ? this.whatsNewBM
                            : this.whatsNewEN;
                },
                error: (err) => {
                    console.log('Error: ', err);
                },
            });
    }

    processWhatsNewLanguages(item: any, bmArray: any[], enArray: any[]) {
        let newObj;
        const details = item?.campaigndetails || [];
        for (let detail of details) {
            newObj = { ...item, campaigndetails: detail };
            if (detail?.languages === 'BM') {
                bmArray.push(newObj);
            } else if (detail?.languages === 'EN') {
                enArray.push(newObj);
            }
        }
    }

    viewWhatsNewDetails(data) {
        let whitespace = new Set([' ', '\t', '\n']);
        if (data?.campaigndetails?.isCampaignRequired == 'Yes') {
            let language = '?language=' + this.selectedLanguage;
            console.log('camapginNmae', data);
            let url: any =
                '/campaign/' +
                data.id +
                '/' +
                formatUrlEncode(
                    htmlToString(data['campaigndetails'].campaignDescription),
                );
            //    + language;
            this.router.navigateByUrl(url);
        } else {
            if (data?.campaigndetails?.campaignUrl) {
                if (
                    (data?.campaigndetails?.campaignUrl ?? '').includes(
                        'https://',
                    ) ||
                    (data?.campaigndetails?.campaignUrl ?? '').includes(
                        'http://',
                    ) ||
                    (data?.campaigndetails?.campaignUrl ?? '').includes(
                        'www',
                    ) ||
                    (data?.campaigndetails?.campaignUrl ?? '').includes('/')
                ) {
                    if (data?.ctaType == this.EXTERNAL) {
                        window.open(
                            data?.campaigndetails?.campaignUrl,
                            '_blank',
                        );
                    } else {
                        window.open(
                            data?.campaigndetails?.campaignUrl,
                            '_self',
                        );
                    }
                } else {
                    for (
                        let i = 0;
                        i < data?.campaigndetails?.campaignUrl?.length;
                        i++
                    ) {
                        if (
                            whitespace.has(
                                data?.campaigndetails?.campaignUrl[i],
                            )
                        ) {
                            if (this.selectedLanguage == 'bm') {
                                this.toastr.error(
                                    'Oops. Terdapat ralat dalam sistem.',
                                );
                            } else {
                                this.toastr.error('Oops.Something went wrong.');
                            }
                        } else {
                            let productCode =
                                data?.campaigndetails?.campaignUrl;
                            this.router.navigate(['/login'], {
                                queryParams: {
                                    returnUrl: `/business-financing?productCode=${productCode}`,
                                },
                            });
                        }
                    }
                }
            } else {
                if (this.selectedLanguage == 'bm') {
                    this.toastr.error('Oops. Terdapat ralat dalam sistem.');
                } else {
                    this.toastr.error('Oops.Something went wrong.');
                }
            }
        }
    }

    onLanguageChange(data: any) {
        this.selectedLanguage = data;
        if (this.selectedLanguage == 'bm') {
            this.whatsNewData = this.whatsNewBM;
        } else if (this.selectedLanguage == 'en') {
            this.whatsNewData = this.whatsNewEN;
        }

        // Force change detection and reinitialize carousel
        this.cdr.detectChanges();

        // Reinitialize carousel after language change
        setTimeout(() => {
            if (this.slickCarousel) {
                this.slickCarousel.unslick();
                this.slickCarousel.initSlick();
            }
        }, 100);
    }

    onSubmitNewApp(draftStatus?) {
        let productData = {};

        if (draftStatus == 'startNewApp') {
            productData['deleteAndContinue'] = true;
        }

        if (this.getUtmSource && this.getUtmId == 'BRP') {
            productData['source'] = this.getUtmSource;
        } else if (this.getUtmId == 'CIDB') {
            productData['source'] = this.getUtmId;
        }

        if (this.isAuthenticated) {
            this.applicationService.createCaseProduct(productData).subscribe({
                next: (res: any) => {
                    let response = res;
                    if (response.drafts) {
                        let draftData = response.drafts;
                        if (
                            draftData.length > 0 &&
                            draftStatus !== 'startNewApp'
                        ) {
                            let selectedProductCode =
                                draftData[0].selectedProducts;
                            let selectedProductName = draftData[0].productName;
                            this.confirmDraftDialog(
                                draftData,
                                selectedProductCode,
                                'checkMatchingProducts',
                                selectedProductName,
                            );
                        } else if (
                            draftData.length > 0 &&
                            draftStatus == 'startNewApp'
                        ) {
                            draftData.forEach((element) => {
                                this.caseId = element.caseId;
                            });
                            this.router.navigate(['/corporate'], {
                                state: {
                                    setProductDetails: this.caseId,
                                    checkMatchingProduct: true,
                                },
                            });
                        }
                    } else {
                        response.forEach((element) => {
                            this.caseId = element.caseId;
                        });
                        this.router.navigate(['/corporate'], {
                            state: {
                                setProductDetails: this.caseId,
                                checkMatchingProduct: true,
                            },
                        });
                    }
                },
                error: (err) => {
                    this.toastr.error(err.error.message);
                },
            });
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: `/business-financing`,
                },
            });
        }
    }

    // to display modal when user click on start new application and have draft application
    confirmDraftDialog(
        draftData,
        selectedProductCode?,
        appProductFlow?,
        selectedProductName?,
        prodCode?,
    ) {
        let noOfDrafts = draftData.length;
        const dialogRef = this.dialog.open(ModalComponent, {
            data: {
                noOfDrafts,
            },
            scrollStrategy: new NoopScrollStrategy(),
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.data == 'resumeDraft') {
                draftData.forEach((element) => {
                    this.caseId = element.caseId;
                });
                let qType;
                draftData.map((ele) => {
                    qType = ele.qType;
                });
                this.resumeApp(
                    this.caseId,
                    qType,
                    selectedProductCode,
                    selectedProductName,
                );
            } else if (result.data == 'startNewApp') {
                if (appProductFlow == 'checkMatchingProducts') {
                    this.onSubmitNewApp('startNewApp');
                    // } else if (appProductFlow == 'selectProduct') {
                    //     this.onSelectProduct(prodCode, 'startNewApp');
                    // }
                }
            }
        });
    }

    // navigate based on resume application queue
    resumeApp(
        caseId: string,
        qType: string,
        selectedProduct?: string,
        selectedProductName?: string,
    ) {
        const matchedProductsFlowArr = [
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGC_USR_INFO',
            'LOAN_CGC_UPD_USR_INFO',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGC_BSNS_INFO',
            'LOAN_CGC_FI_OFFR_SCR',
            'LOAN_CGC_UPLD_DOC',
        ];
        const selectProductFlowArr = [
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGCP_UPD_USR_INFO',
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGCP_BSNS_INFO',
            'LOAN_CGCP_chk_elig',
            'LOAN_CGCP_UPLD_DOC',
        ];
        let appProductFlow;
        let isMatchedProductsFlow;
        if (matchedProductsFlowArr.includes(qType)) {
            appProductFlow = 'checkMatchingProducts';
            isMatchedProductsFlow = true;
        } else if (selectProductFlowArr.includes(qType)) {
            appProductFlow = 'selectProduct';
            isMatchedProductsFlow = false;
        }

        const navigationExtras = {
            state: {
                fromResume: true,
            },
        };
        if (appProductFlow == 'checkMatchingProducts') {
            navigationExtras.state['checkMatchingProduct'] = true;
        }

        if (this.getAppStepNo(qType) == 1) {
            navigationExtras.state['setProductDetails'] = caseId;
            navigationExtras.state['productName'] = selectedProductName;
            this.router.navigate(['/corporate'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 2) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 3) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 4) {
            //check-eligibility flow
            let productFlowData = {
                caseId: caseId,
                prodCode: selectedProduct,
                productFlow: isMatchedProductsFlow,
            };
            navigationExtras.state['productFlowData'] = productFlowData;
            this.router.navigate(['/business-info'], navigationExtras);
        } else {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/corporate'], navigationExtras);
        }
    }

    // get application step number based on queue
    getAppStepNo(qType: string) {
        let step1Arr = [
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGC_USR_INFO',
        ];
        let step2Arr = ['LOAN_CGCP_UPD_USR_INFO', 'LOAN_CGC_UPD_USR_INFO'];
        let step3Arr = ['LOAN_CGCP_BSNS_INFO', 'LOAN_CGC_BSNS_INFO'];
        let step4Arr = ['LOAN_CGCP_chk_elig', 'LOAN_CGC_FI_OFFR_SCR'];
        let step5Arr = ['LOAN_CGCP_UPLD_DOC', 'LOAN_CGC_UPLD_DOC'];
        if (step1Arr.includes(qType)) {
            return 1;
        } else if (step2Arr.includes(qType)) {
            return 2;
        } else if (step3Arr.includes(qType)) {
            return 3;
        } else if (step4Arr.includes(qType)) {
            return 4;
        } else if (step5Arr.includes(qType)) {
            return 4;
        }
    }

    onClickProducts(href) {
        this.router.navigate([href]);
    }

    formatDate(inputTime: string) {
        let dateObj = new Date(inputTime);
        let month = dateObj.toLocaleString('en-us', { month: 'short' });
        let day = dateObj.getDate();
        let year = dateObj.getFullYear();
        let formattedDate = day + ' ' + month + ' ' + year;

        return formattedDate;
    }

    convertToTimeFormat(dateTimeString: string) {
        return dateTimeString.split(' ')[1];
    }

    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow:
            '<button class="slick-prev"><img src="/assets/images/home/left-arrow.png" alt="Previous" /></button>',
        nextArrow:
            '<button class="slick-next"><img src="/assets/images/home/right-arrow.png" alt="Next" /></button>',
    };

    removeHtmlTags(text: string): string {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.body.textContent || '';
    }

    truncate(str: string, length: number): string {
        str = str || ''; // provide default value manually
        return str.length > length ? str.slice(0, length) + '…' : str;
    }

    onViewMore() {
        this.router.navigate(['/applications']);
    }

    onClickCompleteProfile() {
        this.router.navigate(['/profile']);
    }

    trackByFn(index: number, item: any) {
        return item?.id || index;
    }

    showMoreApplications() {
        this.visibleApplicationCount = this.applicationData.length;
    }
}
